import styled from 'styled-components';

export const ConsentTextWrap = styled.div`
    font-size: 1rem;
    margin-bottom: 1.688rem;
`;

export const Stage7Form = styled.div`
    margin-bottom: 1.875rem;
    font-size: 1rem;

    .consent_title {
        font-size: 1.125rem;
        margin-bottom: 1rem;
    }

    ol {
        padding-left: 1rem;

        li {
            margin-top: 1rem;
            margin-bottom: 1rem;
        }
    }

    ul {
        padding-left: 1rem;

        li {
            margin-top: 1rem;
            margin-bottom: 1rem;
        }

        list-style-type: none;
    }

    .checkbox_addTxt {
        padding-left: 2.5rem;
        margin-bottom: 2rem;

        a {
            text-decoration: underline;
        }
    }

    .checkbox_amountWrap {
        padding-left: 1rem;
    }

    .checkbox_amountTxt {
        margin-bottom: 1rem;
    }
`;

export const Checkbox = styled.label`
    display: block;
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-bottom: 1rem;

    input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    span {
        position: absolute;
        top: 0;
        left: 0;
        width: 1.625rem;
        height: 1.625rem;
        ${props =>props.disabled?'border: 0.063rem solid #666666' :'border: 0.063rem solid ' + props.theme.color};
    }

    input:checked ~ span {
    }

    span:after {
        content: "";
        position: absolute;
        display: none;
    }

    input:checked ~ span:after {
        display: block;
    }

    span:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px; 
        border: solid ${props => props.disabled ? '#7E7E7E' : props.theme.color};
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
`
export const Radiobox = styled.label`
    display: block;
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-bottom: 1rem;

    input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    span {
        position: absolute;
        top: 0;
        left: 0;
        width: 1.625rem;
        height: 1.625rem;
        border-radius: 50%;
        border: 0.063rem solid ${props => props.theme.color};
    }

    input:checked ~ span {
    }

    span:after {
        content: "";
        position: absolute;
        display: none;
    }

    input:checked ~ span:after {
        display: block;
    }

    span:after {
        left: 4.4px;
        top: 4px;
        border:9px solid ${props => props.theme.color};
        border-radius:50%;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
`

export const CheckboxText = styled.div`
    display: inline-block;
    font-size: 1rem;
    padding-left: 2.5rem;
    padding-top: 0.2rem;
`;

export const PrefixInput = styled.div`
    position: relative;

    input {
        box-shadow: none !important;
        border-radius: 0 !important;
        outline: none !important;
        -webkit-appearance: none !important;
        -moz-appearance: none !important;
        appearance: none !important;
        height: 3.125rem;
        width: 100%;
        border: 0.063rem solid ${props => props.theme.color};
        font-size: 1rem;
        box-sizing: border-box;
        padding: 0 1.25rem 0 5rem;
    }

    input:disabled {
        box-shadow: none;
        border-radius: 0;
        background: none;
        border: 0.063rem solid #AAAAAA;
        color: #666666;
    }

    input:focus {
        outline: none;
    }

    &::after {
        position: absolute;
        top: 0.95rem;
        left: 1.5rem;
        font-size: 1rem;
        color: #666666;
        transition: all .05s ease-in-out;
        content: 'SGD';
    }
`;

export const Label = styled.label`
    font-size: 12px;
    color: ${props => props.isError || props.isValidationMsg ? '#EB0A1E' : '#666666'} ;
    margin-bottom: 0.625rem;
    display: ${props => props.isValidationMsg?'block':'inline-block'};
    ${props => props.isError && 'width: 100%;'}
    ${props => props.isError && 'text-align: center;'}
    ${props => props.isValidationMsg && 'text-align:right;'}
`;

export const InputWrap = styled.div`
    display: inline-block;
    width: 100%;
    margin-bottom: 1.438rem;
    position: relative;

    .input_percent {
        color: #666666;
        position: absolute;
        font-size: 1rem;
        top: 2.8rem;
        right: 1.313rem;
    }
`;

export const BackButton = styled.div`
    font-size: 1.125rem;
    background: ${props => props.theme.backBtn.bg};
    height: 3.125rem;
    line-height: 3.125rem;
    min-width: 6.25rem;
    display: inline-block;
    text-align: center;
    color: ${props => props.theme.backBtn.txt};
    margin-right: 0.625rem;
`;

export const ButtonWrap = styled.div`
    display: flex;
`;

export const Button = styled.div`
    font-size: 1.125rem;
    height: 3.125rem;
    line-height: 3.125rem;
    width: 100%;
    display: inline-block;
    text-align: center;
    color: ${props => props.disabled ? '#7E7E7E' : props.theme.mainBtn.txt};
    background: ${props => props.disabled ? '#AAAAAA' : props.theme.mainBtn.bg};
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
`;
